// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__21jD3","author":"Table_author__1rAeB","authorImage":"Table_authorImage__RhkfN","unreadRow":"Table_unreadRow__17Hh0"};